setTimeout(() => {
	let videoBoxes = document.querySelectorAll('.video-box');
	
	videoBoxes.forEach(videoBox => {
		let playButton = videoBox.querySelector('.video-play');
		let video = videoBox.querySelector('.video');
		
		playButton.addEventListener('click', () => {
			video.play();
			video.setAttribute('controls', true);
			videoBox.classList.add('hide-play-button');
		});
		
		video.addEventListener('ended', () => {
			video.currentTime = 0;
			video.removeAttribute('controls');
			videoBox.classList.remove('hide-play-button');
		});
	});
}, 1000);